export default {
  namespaced: true,
  state: {
    attr_formula: [],
    formulas: []
  },
  getters: {
    showFormulas: (state) => (formula) => {
      return state.formulas.find((m) => m.pk === formula)
    },
    show_price: (state) => (value) => {
      if (value.customer != null && value.customer != '') {
        let price = value.prod.prices.find(
          (m) => m.level_id == value.customer.level.id
        )
        if (price != undefined) return price.price
      }
      return value.prod.priceSuggest
    },
    show_attrs: (state) => (attributes) => {
      let attrs = []
      for (let i = 0; i < attributes.length; i++) {
        let attr = state.attr_formula.find((m) => m.pk === attributes[i])
        if (attr) {
          attrs.push(attr)
        }
      }
      return attrs
    },
    show_formula: (state, getters) => (operations) => {
      let formula = []
      let attrs = getters.show_attrs(operations.attributes || [])
      if (typeof operations.formula == 'object' && operations.formula != null) {
        for (let i = 0; i < operations.formula.length; i++) {
          let element = operations.formula[i]
          if (typeof element === 'string' && element.indexOf('var_') != -1) {
            let foundAttr = attrs.find((o) => 'var_' + o.pk == element)
            if (foundAttr) {
              element = foundAttr
            }
          }
          formula.push(typeof element == 'object' ? `${element.name}` : element)
        }
        return {
          formula: formula.toString().replace(/,/g, ''),
          attributes: attrs
        }
      }
      return {
        formula: '',
        attributes: []
      }
    }
  },
  mutations: {
    ADD_FORMULA(state, formula) {
      state.formulas.push(formula)
    },
    ADD_ATTR_FORMULA(state, attr) {
      state.attr_formula.push(attr)
    },
    updateAttrs(state, value) {
      state.attr_formula[value.index] = value.attr
    },
    resetFormulas(state) {
      state.attr_formula = []
      state.formulas = []
    }
  },
  actions: {
    async fetchFormula({ commit, state }, formulaId) {
      let index = state.formulas.findIndex((m) => m.pk === formulaId)
      if (index == -1) {
        let response = await axios.get(`products/formula/${formulaId}`)
        commit('ADD_FORMULA', response.data)
        return response.data
      }
      return state.formulas[index]
    },
    async fetchAttrs({ commit, state }, attributes) {
      let attrs = []
      for (let i = 0; i < attributes.length; i++) {
        let index = state.attr_formula.findIndex((m) => m.pk === attributes[i])
        if (index == -1) {
          let response = await axios.get(
            `products/formulattributes/${attributes[i]}`
          )
          commit('ADD_ATTR_FORMULA', response.data)
          attrs.push(response.data)
        } else {
          attrs.push(state.attr_formula[index])
        }
      }
      return attrs
    },
    async calculator({ dispatch }, operations) {
      let formula = []
      if (typeof operations.formula == 'number') {
        const fetched = await dispatch('fetchFormula', operations.formula)
        operations.formula = fetched.formula
      }
      if (operations.formula != undefined) {
        operations.formula.forEach((element) => {
          if (element == '^') {
            element = '**'
          } else if (
            typeof element === 'string' &&
            element.indexOf('var_') != -1
          ) {
            let ope =
              operations.vars != undefined
                ? operations.vars.find((o) => o.name == element)
                : 0
            element = typeof ope == 'object' ? Number(ope.value) : 0
          }
          formula.push(element)
        })
      }
      let operatored = formula.toString().replace(/,/g, '')
      if (operatored !== undefined && operatored !== '') {
        try {
          let total = eval(operatored)
          if (!isFinite(total)) {
            return { total: Infinity, string: 'formulaDivisionZero' }
          }
          return { total: total === undefined ? 0 : total, string: operatored }
        } catch (error) {
          return {
            total: 0,
            string: 'formulaNoValid'
          }
        }
      }
    },
    async calculatedVars({ dispatch }, operations) {
      let values = {}
      if (operations.formula == null || operations.formula == '') {
        return []
      }
      if (typeof operations.formula == 'number') {
        const fetched = await dispatch('fetchFormula', operations.formula)
        operations.formula = fetched.formula
      }

      if (operations.vars != undefined && operations.vars != '') {
        if (typeof operations.vars == 'string') {
          let count = 0
          operations.vars = operations.vars.split(/[-+*/()^]/g)
          operations.formula.forEach((element) => {
            if (typeof element === 'string' && element.indexOf('var_') != -1) {
              if (!(element in values)) {
                values[element] = isNaN(operations.vars[count])
                  ? 0
                  : operations.vars[count]
              }
              count++
            }
          })
        }
        if (typeof operations.vars == 'object') {
          operations.formula.forEach((element) => {
            if (typeof element === 'string' && element.indexOf('var_') != -1) {
              let inx = operations.vars.findIndex((o) => o.name == element)
              if (inx > -1) {
                values[element] = operations.vars[inx].value
              }
            }
          })
        }
      }
      let vars = Array.from(
        new Set(
          operations.formula.filter(
            (o) => typeof o === 'string' && o.indexOf('var_') !== -1
          )
        )
      )
      let varAssign = []
      for (let i = 0; i < vars.length; i++) {
        let element = vars[i]
        // Se despacha la acción en lugar del getter asíncrono
        let label_name_array = await dispatch('fetchAttrs', [
          Number(element.split('_')[1])
        ])
        let label_name =
          label_name_array != undefined && label_name_array.length > 0
            ? label_name_array[0]
            : {
                name: '',
                attr_type: ''
              }
        varAssign.push({
          label: `${label_name.name}`,
          name: element,
          type: label_name.attr_type,
          value:
            element in values
              ? values[element] == ''
                ? 0
                : values[element]
              : 0
        })
      }

      return varAssign
    },
    updateAttrs({ commit, state }, attribute) {
      let index = state.attr_formula.findIndex((m) => m.pk === attribute.pk)
      if (index > -1) {
        commit('updateAttrs', {
          index: index,
          attr: attribute
        })
      }
    }
  }
}
